import { createSelector } from 'reselect';
import { compare } from './../utility/CompareUtils';

const User = 'user';

const selectUsers = (state) => state.get(User).get('users');
const getUsers = createSelector(selectUsers, (data) => {
  const sortedList = data.sort((a, b) => compare(a.get('id'), b.get('id')));
  return sortedList;
});

const selectFailedMassCreateUsers = (state) => state.get(User).get('usersFailedOnMassCreate');
const getFailedCreatedUsers = createSelector(selectFailedMassCreateUsers, (data) => data);

const selectActionResponse = (state) => state.get(User).get('actionResponse');
const getUserActionResponse = createSelector(selectActionResponse, (data) => data);

const selectIsLoading = (state) => state.get(User).get('isLoading');
const getLoadingStatus = createSelector(selectIsLoading, (data) => data);

export { getUsers, getFailedCreatedUsers, getUserActionResponse, getLoadingStatus };
